import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PhxAddonWrapperComponent } from "./phx-addon-wrapper.component";

@NgModule({
  imports: [CommonModule],
  declarations: [PhxAddonWrapperComponent],
  exports: [PhxAddonWrapperComponent],
})
export class PhxAddonWrapperModule {}
